<div class="splash" *ngIf="showSplash">
  <div class="">
  </div>
    <img src="./assets/icons/interbank.svg" alt="logo-interbank" class="splash__logo">
    <img src="./assets/icons/load.svg" alt="icon-load" class="splash__load">
</div>
